import React, { ComponentType } from 'react';
import { Button, IllustratedMessage } from '@ui5/webcomponents-react';
import '@ui5/webcomponents-fiori/dist/illustrations/tnt/UnsuccessfulAuth.js';
import { useTranslation } from 'react-i18next';
import { IPublicClientApplication } from '@azure/msal-browser';

export const withAuthProviderBarrier =
  <T extends object>(WrappedComponent: ComponentType<T>, pca: IPublicClientApplication) =>
  (props: T) =>
    (
      <AuthProviderBarrier pca={pca}>
        <WrappedComponent {...props} />
      </AuthProviderBarrier>
    );

interface AuthProviderBarrierProps {
  children: React.ReactNode;
  pca: IPublicClientApplication;
}

export const AuthProviderBarrier: React.FC<AuthProviderBarrierProps> = ({ children, pca }) => {
  const { t } = useTranslation();

  const account = pca.getActiveAccount();
  if (account?.authorityType === 'MSSTS') {
    return <>{children}</>;
  }

  return (
    <IllustratedMessage
      data-testid="auth-barrier-illustrated-message"
      name="TntUnsuccessfulAuth"
      titleText={t('auth-barrier-title')}
      subtitleText={t('auth-barrier-subtitle', { name: 'Default Identity Provider' })}
    >
      <Button onClick={() => pca.logoutRedirect()}>{t('auth-barrier-logout')}</Button>
    </IllustratedMessage>
  );
};
